import type { RouteRecordRaw } from 'vue-router';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

// Màn post-login: user tới đây NGAY SAU khi đăng nhập thành công.
// - KHÔNG `onlyGuest` — cơ chế đó đã bị gỡ hẳn ở #1028, cụm màn auth giờ công khai.
// - CÓ `requireAuth` — không có thì khách vãng lai mở thẳng URL vẫn thấy form đặt mật khẩu.
//   Nằm ở AuthLayout: không cần tiệm. Rời màn bằng reload để init quyết đích (TASK-139).
export const setPasswordRoutes = {
  name: 'set-password',
  path: 'set-password',
  components: {
    default: () => import('./SetPassword.vue'),
    brand: () => import('./SetPasswordBrand.vue'),
  },
  meta: { i18n, requireAuth: true },
} satisfies RouteRecordRaw;
